export function formShowroomData(payload){
    let medias = [];
    for (let media of payload?.medias){
        if (media?.file instanceof File) medias.push(media?.file); 
    }
    payload['medias'] = medias; 
    return payload; 
}